import gql from 'graphql-tag';

export const APP_FEATURES = gql`
  query APP_FEATURES {
    appFeatures {
      key
      title
      description
      enabled
    }
  }
`;

export const SET_APP_FEATURE = gql`
  mutation SET_APP_FEATURE($key: String!, $enabled: Boolean!) {
    setAppFeature(key: $key, enabled: $enabled) {
      key
      title
      description
      enabled
    }
  }
`;

export type AppFeature = {
  key: string;
  title: string;
  description: string;
  enabled: boolean;
};

export type AppFeaturesQuery = {
  appFeatures: AppFeature[];
};
